import React from 'react';
import './QariaSadafSarfaraz.css';

const QariaSadafSarfaraz = () => {
  return (
    <div className="tutor-detail-page-wrapper" id="tutor-detail-page">
      {/* Premium Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Qaria Sadaf Sarfaraz</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Qaria Sadaf Sarfaraz</span>
          </nav>
        </div>
      </section>

      {/* Profile Section */}
      <div className="tutor-profile-container">
        {/* Left Side: Sticky Profile Sidebar */}
        <aside className="tutor-profile__sidebar">
          <div className="tutor-profile__sidebar-card">
            <div className="tutor-profile__avatar-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/tutor-yousra.jpeg`}
                alt="Qaria Sadaf Sarfaraz"
                className="tutor-profile__avatar"
              />
            </div>
            <h2 className="tutor-profile__name">Qaria Sadaf Sarfaraz</h2>
            <p className="tutor-profile__role">Online Quran Teacher (Kids & Adult)</p>

            <p className="tutor-profile__badge-header">Expertise</p>


            <div className="tutor-profile__badges-row">
              <span className="tutor-profile__badge-tag">Qaida with Tajweed</span>
              <span className="tutor-profile__badge-tag">Kids & Adults</span>
              <span className="tutor-profile__badge-tag">Quran Completions</span>
            </div>

            <a href="/free-trial/" className="tutor-profile__btn-primary">
              Book Free Trial &rarr;
            </a>

            <a href="/our-tutors/" className="tutor-profile__btn-secondary">
              All Our Tutors &rarr;
            </a>
          </div>
        </aside>

        {/* Right Side: Scrolling Content */}
        <main className="tutor-profile__content">
          {/* About Card */}
          <div className="tutor-profile__card">
            <div className="tutor-profile__card-header">
              <svg className="tutor-profile__card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
              <h2 className="tutor-profile__card-title">About Qaria Sadaf Sarfaraz</h2>
            </div>

            <p className="tutor-profile__bio">
              The highest student satisfaction rate in the first class, most students continue after their trial session.
            </p>

            {/* Subjects Grid */}
            <div className="tutor-profile__subjects-grid">
              {/* Subject 1: Quran Reading (Nazra) */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 2H6c-1.2 0-2 .8-2 2v16c0 1.2.8 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H6V4h12v16zm-2-8h-8v-2h8v2zm0-4h-8V6h8v2z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Quran Reading (Nazra)</h3>
                  <p className="tutor-subject-card__desc">Proper Quran reading with Tajweed.</p>
                </div>
              </div>

              {/* Subject 2: Quran with Tajweed */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 2H6c-1.2 0-2 .8-2 2v16c0 1.2.8 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H6V4h12v16zm-2-8h-8v-2h8v2zm0-4h-8V6h8v2z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Quran with Tajweed</h3>
                  <p className="tutor-subject-card__desc">Quran reading with Tajweed rules.</p>
                </div>
              </div>

              {/* Subject 3: Quran Memorization (Hifz) */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 2H6c-1.2 0-2 .8-2 2v16c0 1.2.8 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H6V4h12v16zm-2-8h-8v-2h8v2zm0-4h-8V6h8v2z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Quran Memorization (Hifz)</h3>
                  <p className="tutor-subject-card__desc">Quran Memorization (Hifz) with Tajweed rules.</p>
                </div>
              </div>

              {/* Subject 4: Quran Translation */}
              <div className="tutor-subject-card">
                <div className="tutor-subject-card__icon-wrapper">
                  <svg className="tutor-subject-card__icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 2H6c-1.2 0-2 .8-2 2v16c0 1.2.8 2 2 2h13c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 18H6V4h12v16zm-2-8h-8v-2h8v2zm0-4h-8V6h8v2z" />
                  </svg>
                </div>
                <div className="tutor-subject-card__info">
                  <h3 className="tutor-subject-card__title">Quran Translation</h3>
                  <p className="tutor-subject-card__desc">Online Quran translation classes with meaning.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Teaching Methodology Card */}
          <div className="tutor-profile__card">
            <div className="tutor-profile__card-header">
              <svg className="tutor-profile__card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
              <h2 className="tutor-profile__card-title">Teaching Methodology</h2>
            </div>

            <p className="tutor-profile__bio">
              Qaria Sadaf Sarfaraz follows a structured and student-friendly teaching methodology focused on clear understanding and steady progress. She begins by assessing each student’s level and then designs personalized lessons for Quran Reading (Nazra) with proper Tajweed rules. Her teaching also includes Quran Memorization (Hifz) with regular revision, as well as Quran Translation to help students understand meanings. She ensures interactive and engaging sessions for both kids and adults, making learning simple, consistent, and effective. Her approach is centered on practice, repetition, and student satisfaction, with most learners continuing beyond the trial session.
            </p>

            {/* Features list */}
            <div className="tutor-profile__features-list">
              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Tailored Learning Plans:</strong>
                  <span>Customized lessons for international students of all levels.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Specialization:</strong>
                  <span>Online Quran classes with interactive and engaging sessions for kids and adults.</span>
                </div>
              </div>


              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Innovative Methods:</strong>
                  <span>Uses creative techniques to keep students motivated and engaged.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Correction &amp; Fluency:</strong>
                  <span>Focuses on correcting pronunciation errors patiently until mastery.</span>
                </div>
              </div>

              <div className="tutor-profile__feature-row">
                <div className="tutor-profile__check-icon-wrapper">
                  <svg className="tutor-profile__check-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <div className="tutor-profile__feature-item-text">
                  <strong>Student Retention:</strong>
                  <span>Known for building strong bonds with students, encouraging long-term learning.</span>
                </div>
              </div>


            </div>
          </div>
        </main>
      </div>

      {/* Specially Designed Quran Courses Section */}
      <section className="tutor-courses-section">
        <div className="tutor-courses__container">
          <h2 className="tutor-courses__heading">
            Our Specially Designed Quran Courses To <br /> Improve Quranic Education

          </h2>

          <div className="tutor-courses__grid">
            {/* Card 1 */}
            <a href="/noorani-qaida-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg aria-hidden="true" className="tutor-courses__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Noorani Qaida Course</h3>
              <p className="tutor-courses__card-text">
                Learn Noorani Qaida online from expert male and female tutors. Perfect for kids and adults who want to build a strong foundation in Quran recitation with proper pronunciation and Tajweed rules.
              </p>
            </a>

            {/* Card 2 */}
            <a href="/online-tajweed-classes-tajweed-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg className="tutor-courses__icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.42 2.72 6.2 6 6.72V21h2v-3.28c3.28-.52 6-3.3 6-6.72h-1.7z" />
                </svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Tajweed Classes</h3>
              <p className="tutor-courses__card-text">
                Learn Quran with tajweed online from expert male and female tutors. Whether you are a kid or an adult. We teach everyone with proper guidance.
              </p>
            </a>

            {/* Card 3 */}
            <a href="/quran-reading-classes-online-for-kids-and-adults/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg aria-hidden="true" className="tutor-courses__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Reading Classes Online</h3>
              <p className="tutor-courses__card-text">
                Get online Quran recitation classes with Juzz by Juzz to learn and improve your Quran reading capabilities, no matter if you are an adult or a kid.
              </p>
            </a>

            {/* Card 4 */}
            <a href="/quran-memorization-classes-course/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg className="tutor-courses__icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.42 2.72 6.2 6 6.72V21h2v-3.28c3.28-.52 6-3.3 6-6.72h-1.7z" />
                </svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Memorization Classes</h3>
              <p className="tutor-courses__card-text">
                Our Quran memorization course intends to help the students to memorize the Holy Quran with experienced and professional Huffaz.
              </p>
            </a>

            {/* Card 5 */}
            <a href="/quran-translation-classes/" className="tutor-courses__card">
              <div className="tutor-courses__icon-wrapper">
                <svg className="tutor-courses__icon" aria-hidden="true" fill="currentColor" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"></path></svg>
              </div>
              <h3 className="tutor-courses__card-title">Quran Translation Classes Online</h3>
              <p className="tutor-courses__card-text">
                This course is especially designed for students who want to learn to translate Quran so that they are able to understand the meaning of the verses of Quran.
              </p>
            </a>
          </div>
        </div>
      </section>

      {/* Testimonials Section: Their Stories Speak For Us */}
      <section className="tutor-stories-section">
        <div className="tutor-stories__container">
          <div className="tutor-stories__badge-wrapper">
            <span className="tutor-stories__badge">Real Students, Real Results</span>
          </div>

          <h2 className="tutor-stories__heading">Their Stories Speak For Us</h2>

          <p className="tutor-stories__subtitle">
            Real Students, Real Progress. Every Story Below Is From A Verified Student Of Al Quran Lesson.
          </p>

          <div className="tutor-stories__grid">
            {/* Story 1 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                My daughter was struggling with basic Arabic letters. After just 4 months with her tutor, she can read the Quran fluently. The one-on-one attention made all the difference — her confidence has completely transformed.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Sarah M</span>
                  <p className="tutor-stories__student-meta">Texas, USA &middot; Parent</p>
                </div>
                <span className="tutor-stories__duration-badge">4 months</span>
              </div>
            </div>

            {/* Story 2 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                I started as a complete beginner at age 35. I was worried it would be too late. Ustadh Ahmed was incredibly patient and within 6 months I completed my first Juz with proper Tajweed. Alhamdulillah.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Khalid A.</span>
                  <p className="tutor-stories__student-meta">Ontario, Canada &middot; Adult</p>
                </div>
                <span className="tutor-stories__duration-badge">6 months</span>
              </div>
            </div>

            {/* Story 3 */}
            <div className="tutor-stories__card">
              <div className="tutor-stories__quote-icon">“</div>
              <p className="tutor-stories__text">
                Both my sons (ages 7 and 10) take classes here. The female tutor option was very important for my daughter too. Scheduling is flexible and they never missed a class in 8 months. Highly recommend.
              </p>
              <div className="tutor-stories__divider"></div>
              <div className="tutor-stories__footer">
                <div className="tutor-stories__student-info">
                  <span className="tutor-stories__student-name">Fatima R.</span>
                  <p className="tutor-stories__student-meta">New York, USA &middot; Parent</p>
                </div>
                <span className="tutor-stories__duration-badge">8 months</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <div
        className="tutor-parallax-wrapper"
        style={{
          '--bg-parallax': `url('${process.env.PUBLIC_URL}/assets/images/Hero-4.jpg')`
        }}
      >
        <section className="tutor-how-it-works-section" id="how-it-works">
          <div className="tutor-how-it-works__container">
            <div className="tutor-how-it-works__badge">HOW IT WORKS</div>

            <h2 className="tutor-how-it-works__title">
              How To Start Online Quran Classes In 3 Simple Steps
            </h2>

            <div className="tutor-how-it-works__steps-container">
              {/* Step 1 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 1</h3>
                <h4 className="tutor-how-it-works__step-title">Book Your Free Trial</h4>
                <p className="tutor-how-it-works__step-desc">
                  Fill out our simple form with your name, location, course interest, and preferred time. It takes less than 2 minutes.
                </p>
              </div>

              {/* Step 2 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 2</h3>
                <h4 className="tutor-how-it-works__step-title">Get Matched with Your Tutor</h4>
                <p className="tutor-how-it-works__step-desc">
                  We match you or your child with a certified tutor based on your level, gender preference, and schedule. Your first session is arranged within 24 hours.
                </p>
              </div>

              {/* Step 3 */}
              <div className="tutor-how-it-works__step">
                <div className="tutor-how-it-works__icon-wrapper">
                  <svg className="tutor-how-it-works__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                  </svg>
                </div>
                <h3 className="tutor-how-it-works__step-num">Step 3</h3>
                <h4 className="tutor-how-it-works__step-title">Start Learning &amp; Track Progress</h4>
                <p className="tutor-how-it-works__step-desc">
                  Attend your live one-on-one sessions, receive feedback after every class, and track measurable progress through our structured curriculum. Your journey begins on Day 1.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default QariaSadafSarfaraz;

